module.exports = __webpack_public_path__ + "static/canadian-tire-logo-a9dbfbbf7a2a05067a8d8024f367ac6e.png";